import React from "react";
import { observer } from "mobx-react";
import { FacilityMissingDocsPreviewTemplate } from "themes/application/facility-missing-docs/pages";
import { FacilityMissingDocsPreviewViewStore } from "application/facility-missing-docs/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityMissingDocsPreviewViewStore(rootStore), "facilityMissingDocsPreviewViewStore")
@observer
class FacilityMissingDocsPreview extends React.Component {
	render() {
		return <FacilityMissingDocsPreviewTemplate {...this.props} />;
	}
}

export default FacilityMissingDocsPreview;